import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import { VOUCHER_TYPE_OPTIONS } from "@/constants/voucherType";
import ProductOfferedCreate from "./ProductOfferedCreate";
import ProductOfferedEdit from "./ProductOfferedEdit";

export const productsoffered = {
  create: ProductOfferedCreate,
  edit: ProductOfferedEdit,
  icon: CardGiftcardIcon,
  options: {
    label:
      VOUCHER_TYPE_OPTIONS.find((t) => t.value === "free_product")?.label ||
      "Free Product",
  },
};
